import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => {
  const { fontSize, fontWeight, fontFamily, spacing, typeColor } = theme;

  return {
    wrenchLabel: ({ muted, plain }) => ({
      display: 'block',
      color: typeColor.dark,
      fontFamily: fontFamily.base,
      '-webkit-font-smoothing': 'antialiased',
      boxSizing: 'border-box',
      fontSize: fontSize.bodySm,
      padding: 0,
      margin: [0, 0, spacing[1]],
      fontWeight: fontWeight.medium,
      ...(plain && {
        fontWeight: fontWeight.regular,
        fontSize: fontSize.body,
      }),
      ...(muted && {
        color: typeColor.darkMuted,
        fontWeight: fontWeight.regular,
      }),
    }),
  };
});

export default useStyles;
